export default __webpack_public_path__ + "static/media/3.909373ab.jpeg";